import { UserLoginResponse } from '@app/api/auth.api';
import { UserModel } from '@app/domain/UserModel';
const avatarImg = process.env.REACT_APP_ASSETS_BUCKET + '/avatars/avatar5.webp';

const testUser = {
  id: 1,
  firstName: 'Chris',
  lastName: 'Johnson',
  imgUrl: avatarImg,
  userName: '@john1989',
  email: {
    name: 'chris.johnson@altence.com',
    verified: true,
  },
  phone: {
    number: '+18143519459',
    verified: false,
  },
  sex: 'male',
  birthday: '01/26/2022',
  lang: 'en',
  country: 'GB',
  city: 'London',
  address1: '14 London Road',
  zipcode: 5211,
  website: 'altence.com',
  socials: {
    twitter: '@altence_team',
    facebook: 'https://facebook.com/groups/1076577369582221',
    linkedin: 'https://linkedin.com/company/altence',
  },
};

export const persistToken = (token: UserLoginResponse): void => {
  if (token) {
    localStorage.setItem('accessToken', JSON.stringify(token));
  }
};

export const readUserToken = (): UserLoginResponse | null => {
  const data = localStorage.getItem('accessToken') || '';
  if (data) {
    const parsedData: UserLoginResponse = JSON.parse(data);
    return parsedData;
  }
  return null;
};

export const readToken = (): string => {
  return localStorage.getItem('accessToken') || '';
};

export const persistUser = (user: UserModel): void => {
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
};

export const persistLoginUser = (user: UserModel): void => {
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
};

export const readUser = (): UserModel | null => {
  const userStr = localStorage.getItem('user');

  return userStr ? JSON.parse(userStr) : testUser;
};

export const deleteToken = (): void => localStorage.removeItem('accessToken');
export const deleteUser = (): void => localStorage.removeItem('user');
